import { Language } from '@dvinci/attract-studio-components'

export const DEFAULT_LANGUAGE: Language = 'de'

export const LANGUAGE_SUFFIX_REDIRECTS: Language[] = ['de', 'en']

export const withDefaultLanguage = (activeLanguages: Language[]): Language[] =>
  activeLanguages.includes(DEFAULT_LANGUAGE) ? activeLanguages : [DEFAULT_LANGUAGE, ...activeLanguages]
